import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { sentenceCase } from '../../../../utils/utils';
import ActionButton from '../../../elements/action-button/ActionButton';
import Modal from '../../../sections/modal/Modal';

const DeleteCardModal = ({ visible, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal
      openModal={visible}
      title={t('confirmation', {
        ns: 'sectionTitles',
        text: t('billing.creditCard', { ns: 'project' }),
      })}
      handleClose={onClose}
    >
      <Alert severity="error" sx={{ mb: 2 }}>
        {t('cantUndo', { ns: 'descriptions' })}
      </Alert>
      {sentenceCase(
        t('areYouSure', {
          ns: 'descriptions',
          text: t('billing.creditCard', { ns: 'project' }),
        })
      )}
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button variant="text" onClick={onClose}>
          {t('cancel', { ns: 'buttons' })}
        </Button>
        <ActionButton color="error" clickAction={onConfirm}>
          {t('delete', { ns: 'buttons' })}
        </ActionButton>
      </Box>
    </Modal>
  );
};

DeleteCardModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default DeleteCardModal;
